let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("7ouuO"), load("9uS8C")]).then(() => parcelRequire('eg7HA'));